module.exports = {
    props: ['user']
};



// WEBPACK FOOTER //
// ./spark/resources/assets/js/settings/profile.js